export default {
  sample: function(sample, template, size) {
    template = template || 'Pie';
    const [cols, rows] = size.split('x');
    if (cols == 1 && rows == 1) {
      return sample;
    }

    sample.chartName = `Multi-Pie ${cols}x${rows}`;
    sample.aspectRatio = `${cols}:${rows}`;

    const serie = sample.series[0];
    sample.series = [];
    const title = sample.title[0];
    sample.title = [];

    sample.grid = [];

    let {
      radius,
      center: [centerX, centerY],
    } = serie;
    radius = parseInt(radius) / 100;
    centerX = 100 / parseInt(centerX);
    centerY = 100 / parseInt(centerY);

    const dx = 100 / cols;
    const dy = 100 / rows;
    const dr = Math.max(dx, dy);
    const dmax = Math.max(dx, dy);
    const dmin = Math.min(dx, dy);

    for (let x = 0; x < cols; x++) {
      for (let y = 0; y < rows; y++) {
        sample.series.push({
          ...serie,
          type: 'multipie',
          originalType: 'pie',
          name: `${template}-${x + 1}-${y + 1}`,
          center: [`${dx / centerX + dx * x}%`, `${dy / centerY + dy * y}%`],
          radius: `${dr * radius}%`,
          emphasis: {
            label: {
              show: true,
            },
          },
          label: {
            color: 'rgba(255, 255, 255, 0.3)',
            show: false,
          },
        });
        sample.title.push({
          ...title,
          text: `${x + 1}-${y + 1}`,
          left: `${dx / 25 + dx * x}%`,
          top: `${dy / 25 + dy * y}%`,
          textStyle: {
            color: 'rgba(255,255,255,0.5)',
            fontSize: `${Math.max(dmin / 2, 10)}`,
          },
          padding: 0,
        });

        sample.grid.push({
          show: true,
          borderWidth: 1,
          borderColor: 'rgba(255,255,255,0.2)',
          left: `${x && dx / 50 + dx * x}%`,
          top: `${y && dy / 50 + dy * y}%`,
          right: `${100 + (cols - x - 1 && dx / 50) - dx * (x + 1)}%`,
          bottom: `${100 + (rows - y - 1 && dy / 50) - dy * (y + 1)}%`,
          backgroundColor: 'rgba(255,255,255,0.05)',
        });
      }
    }

    return sample;
  },
};
